import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=481f330e&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js&"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=481f330e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481f330e",
  null
  
)

export default component.exports